import { aboutData } from '@/mocks/cinema';

export default function SectionAbout() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="section-container px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-primary-500/10 flex items-center justify-center text-3xl">
            🐱
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-4">
            {aboutData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-2xl mx-auto">
            {aboutData.description}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-400">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-600 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}